import { FunctionComponent, useMemo } from "react";
import { DirectionItem, DirectionItemType } from "./DirectionListItem";
import { ItemDirectionStep } from "@domain/ItemDirection";
import { formatDistance } from "@lib/calculateDistance";

import "./DirectionsList.css";

const styles = {} as any;

const DirectionsList: FunctionComponent<{
  steps: ItemDirectionStep[];
  stopAddress: string;
  stopName: string;
}> = ({ steps, stopAddress, stopName }) => {
  const stepsWithDestination = useMemo(() => {
    return steps
      .map((step, index) => {
        const distance = formatDistance(step.distanceInMeters);

        const instructions = step.instructions.replace(/<div.*/, "");
        return {
          title: instructions,
          subtitle: `${distance.distanceFormatted} ${distance.unit}`,
          manuever: step.manuever,
          key: index,
        } as DirectionItemType;
      })
      .concat([
        {
          key: -1,
          manuever: "destination",
          subtitle: stopAddress,
          title: stopName,
        } as DirectionItemType,
      ]);
  }, [steps, stopAddress, stopName]);

  return (
    <div style={styles.container} className="directions-list-component">
      {stepsWithDestination.map((step) => (
        <DirectionItem key={step.key} item={step} />
      ))}
    </div>
  );
};

export { DirectionsList };
